import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, Typography} from "@mui/material";
import Divider from "@mui/material/Divider";
import {useState} from "react";
import { TEXT_BTN, TYPES_ALERTS } from "../../Constants/Const";
import {TransitionAlerts} from "../../Global/AlertComonent";

export function AddNewManualDialog({open=null,handlingCloseDialog=null}){

    const [ file, setFile ] = useState(null)


    const handlingAddFile = (event) =>{
        setFile(event.target.files);
    };

    const handlingAccept = async () => {
        handlingCloseDialog()
        TransitionAlerts({
            open: true,
            message: file.name,
            type: TYPES_ALERTS.success
        });
    }


    return(
        <Dialog open={open} onClose={handlingCloseDialog} maxWidth="lg">
            <DialogTitle>
                <Typography variant="h5" >Nuevo Manual</Typography>
            </DialogTitle>
            <Divider/>
            <DialogContent>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <TextField
                            type="file"
                            onChange={handlingAddFile}
                            inputProps={{ multiple: true }}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <Divider/>
            <DialogActions>
                <Button variant="contained" color="error" onClick={handlingCloseDialog}>
                    <Typography variant='button'>{TEXT_BTN.exit}</Typography>
                </Button>
                <Button variant="contained" color="success" onClick={handlingAccept}>
                    <Typography variant='button'>{TEXT_BTN.accepted}</Typography>
                </Button>
            </DialogActions>
        </Dialog>
    );

}